import { render, staticRenderFns } from "./about.vue?vue&type=template&id=faef3fd4&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"
import style0 from "./about.vue?vue&type=style&index=0&id=faef3fd4&prod&lang=less"
import style1 from "./about.vue?vue&type=style&index=1&id=faef3fd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faef3fd4",
  null
  
)

export default component.exports